// Judge.me renders its own review cards asynchronously into the reviews-photo-gallery section — this
// (a) relocates those cards (once they appear) into the theme's own scroll-carousel component so they can
// be browsed 3-at-a-time with swipe/drag, matching the pattern used elsewhere on the site (e.g. related
// products), and (b) adds a "Read more" toggle for long reviews, since this Judge.me installation doesn't
// provide its own truncation UI and the review body is CSS-clamped to 4 lines.
(function () {
  var ARROW_LEFT = '<svg aria-hidden="true" focusable="false" fill="none" width="16" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square"/></svg>';
  var ARROW_RIGHT = '<svg aria-hidden="true" focusable="false" fill="none" width="16" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"/></svg>';

  // .jdgm-rev is the legacy Judge.me widget's review card class; .jm-review-item is the newer
  // "revamped" widget's equivalent (Judge.me pushed a widget update mid-project, confirmed via live
  // DOM inspection). Matching both keeps this working regardless of which version is active.
  var REVIEW_SELECTOR = '.jdgm-rev-widg__reviews .jdgm-rev, .jdgm-rev-widg__body .jdgm-rev, .jdgm-rev, .jm-review-item';
  var carouselBuilt = false;

  function buildCarousel(reviewNodes) {
    if (carouselBuilt || reviewNodes.length < 2) {
      return;
    }

    var list = reviewNodes[0].parentElement;

    if (!list || list.closest('.reviews-carousel')) {
      return;
    }

    carouselBuilt = true;

    var carouselId = 'reviews-carousel-' + Date.now();

    var wrap = document.createElement('div');
    wrap.className = 'reviews-carousel floating-controls-container floating-controls-container--inside floating-controls-container--on-hover';

    var prev = document.createElement('carousel-prev-button');
    prev.className = 'floating-controls-container__control';
    prev.setAttribute('aria-controls', carouselId);
    prev.innerHTML = '<button type="button" class="prev-next-button prev-next-button--prev circle-button" disabled><span class="sr-only">Previous</span>' + ARROW_LEFT + '</button>';

    var carousel = document.createElement('scroll-carousel');
    carousel.id = carouselId;
    carousel.setAttribute('group-cells', '');
    carousel.setAttribute('allow-drag', '');
    carousel.className = 'reviews-carousel__track scroll-area';

    var next = document.createElement('carousel-next-button');
    next.className = 'floating-controls-container__control';
    next.setAttribute('aria-controls', carouselId);
    next.innerHTML = '<button type="button" class="prev-next-button prev-next-button--next circle-button"><span class="sr-only">Next</span>' + ARROW_RIGHT + '</button>';

    reviewNodes.forEach(function (node) {
      node.classList.add('reviews-carousel__cell');
      carousel.appendChild(node);
    });

    wrap.appendChild(prev);
    wrap.appendChild(carousel);
    wrap.appendChild(next);

    list.appendChild(wrap);

    // Minimal dot indicators in place of Judge.me's own numbered pagination (hidden via CSS). Dot count
    // reflects groups of 3, matching the carousel's grouping — this doesn't recompute per breakpoint, so
    // it's tuned for the desktop 3-per-view layout specifically.
    var groupCount = Math.ceil(reviewNodes.length / 3);

    if (groupCount > 1) {
      var nav = document.createElement('carousel-navigation');
      nav.setAttribute('aria-controls', carouselId);
      nav.className = 'page-dots page-dots--narrow reviews-carousel__dots';

      for (var i = 0; i < groupCount; i++) {
        var dot = document.createElement('button');
        dot.className = 'relative';
        dot.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        dot.innerHTML = '<span class="sr-only">Go to review group ' + (i + 1) + '</span>';
        nav.appendChild(dot);
      }

      wrap.appendChild(nav);
    }
  }

  function addReadMoreToggles(reviewNodes) {
    reviewNodes.forEach(function (node) {
      var body = node.querySelector('.jdgm-rev__body');

      if (!body || body.dataset.readMoreChecked) {
        return;
      }

      body.dataset.readMoreChecked = 'true';

      // Let the line-clamp layout settle before measuring whether it actually overflows.
      requestAnimationFrame(function () {
        if (body.scrollHeight <= body.clientHeight + 1) {
          return;
        }

        var toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'jdgm-rev__read-more link text-xs';
        toggle.textContent = 'Read more';

        toggle.addEventListener('click', function () {
          var expanded = body.classList.toggle('jdgm-rev__body--expanded');
          toggle.textContent = expanded ? 'Read less' : 'Read more';
        });

        body.insertAdjacentElement('afterend', toggle);
      });
    });
  }

  var tabsFilterHidden = false;
  var titleBadgeCorrected = false;

  // Styles the Judge.me widget's own internal "Customer Reviews" title (sits above the star summary)
  // to match the theme's h2 heading look, so it reads consistently with the page's other headings now
  // that the separate rich-text "Customer Reviews" heading above it is disabled. Matched by exact
  // trimmed text on a leaf element (no child elements) rather than a class name, since Judge.me's class
  // names have changed once already this project (the "revamped" widget update) and a text match is
  // more resilient to that than guessing at their current markup.
  function styleWidgetTitle() {
    // Styles every match, not just the first, and keeps re-checking on every mutation rather than
    // stopping after one hit — if the page ever has more than one "Customer Reviews" text node (or the
    // real widget one isn't in the DOM yet on an early pass), stopping after the first match risked
    // styling the wrong element and never trying again.
    var candidates = document.querySelectorAll('h1, h2, h3, h4, h5, h6, div, span, p');
    var matched = 0;

    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];

      if (
        el.children.length === 0 &&
        (el.textContent || '').trim() === 'Customer Reviews' &&
        !el.classList.contains('jdgm-widget-title-matched')
      ) {
        el.classList.add('jdgm-widget-title-matched');
        console.log('[reviews-carousel-group] styled widget title via text match:', el);
        matched++;
      }
    }
  }

  // Finds the "Product reviews (N)" tab element — proven to match reliably (confirmed via console log
  // when this same match was used to hide the tabs/filter row) — and returns both the element and the
  // parsed count, so other functions can reuse the exact same, already-verified match instead of each
  // guessing at their own text pattern against Judge.me's markup.
  function findProductReviewsTab() {
    var all = document.querySelectorAll('button, a, div, span, p');

    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      var text = (el.textContent || '').trim();
      var match = text.match(/^product reviews\s*\((\d+)\)/i);

      if (match) {
        return { el: el, count: parseInt(match[1], 10) };
      }
    }

    return null;
  }

  // Hides Judge.me's redundant header block (duplicate "Customer Reviews" title, the "X.X (N reviews)"
  // summary, and the "Product reviews / Store reviews" tabs + filter/sort row) — matched by visible text
  // rather than a class name, since a second Judge.me widget instance on the page may not share the same
  // class structure as the first one the CSS-based hiding rules were built against.
  function hideReviewTabsAndFilters(tab) {
    if (tabsFilterHidden || !tab) {
      return;
    }

    var container = tab.el.closest('[class*="header"]');

    // Safety check: never hide a container that also holds the actual review cards — if the closest
    // "header"-classed ancestor happens to wrap everything, walk back down to something narrower instead
    // of risking hiding real content.
    if (container && container.querySelector(REVIEW_SELECTOR)) {
      container = null;
    }

    if (container) {
      container.style.display = 'none';
      tabsFilterHidden = true;
      console.log('[reviews-carousel-group] hid header/tabs/filter block via text match:', container);
    }
  }

  // The title badge (pdp-shop-rating.js) reads a data attribute scraped from elsewhere on the page, which
  // has proven unreliable (showed a stale/wrong count that didn't match the widget). This overrides its
  // count with the number from the same "Product reviews (N)" match used above — a value already proven
  // to match what's visibly shown in the widget. The star fill is left as whatever pdp-shop-rating.js set
  // (or a full 5-star fallback), since getting the count right is the priority here.
  function updateTitleBadgeFromWidget(tab) {
    if (titleBadgeCorrected || !tab) {
      return;
    }

    var badge = document.querySelector('[data-pdp-shop-rating]');

    if (!badge) {
      return;
    }

    var valueEl = badge.querySelector('[data-pdp-shop-rating-value]');
    var fillEl = badge.querySelector('[data-pdp-shop-rating-fill]');

    if (valueEl) {
      valueEl.textContent = tab.count;
    }

    if (fillEl && !fillEl.style.width) {
      fillEl.style.width = '100%';
    }

    badge.hidden = false;
    titleBadgeCorrected = true;

    // The badge's href="#judgeme_product_reviews" anchor doesn't work — nothing on the page has that ID
    // (the reviews section has been restructured several times, and there are now two separate widget
    // instances). Shopify generates section wrapper IDs like "template--{number}__reviews-photo-gallery"
    // — the numeric prefix varies per page/product, but the "reviews-photo-gallery" suffix (this section's
    // fixed key in the JSON template) doesn't, so matching on that specifically targets the "Review
    // Widget" section at the bottom of the page rather than whichever widget instance happens to be first.
    badge.addEventListener('click', function (event) {
      var target = document.querySelector('[id*="reviews-photo-gallery"]') || document.querySelector(REVIEW_SELECTOR);

      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    console.log('[reviews-carousel-group] corrected title badge count from "Product reviews" tab match:', tab.count);
  }

  function checkForReviews() {
    if (!tabsFilterHidden || !titleBadgeCorrected) {
      var tab = findProductReviewsTab();

      hideReviewTabsAndFilters(tab);
      updateTitleBadgeFromWidget(tab);
    }

    styleWidgetTitle();

    var nodes = document.querySelectorAll(REVIEW_SELECTOR);

    if (nodes.length === 0) {
      return;
    }

    var nodeList = Array.prototype.slice.call(nodes);

    addReadMoreToggles(nodeList);

    if (nodeList.length >= 2) {
      buildCarousel(nodeList);
    }
  }

  checkForReviews();

  var observer = new MutationObserver(function () {
    checkForReviews();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Judge.me widgets are fetched async — give up watching after a reasonable window rather than
  // observing the whole page indefinitely.
  setTimeout(function () {
    observer.disconnect();
  }, 15000);
})();
